import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { REFERRAL_LINK } from '@src/configs';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import { StyledReferralCode } from './index.style';
import ReferralCodeItem from './ReferralCodeItem';
import ReferralCodeSharing from './ReferralCodeSharing';
import EditCodeDialog from './EditCodeDialog';

const ReferralCode = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const [referralCode, setReferralCode] = useState('');
  const [referralCodeLoading, setReferralCodeLoading] = useState(true);
  const dispatch = useDispatch();
  const [openEditCodeDialog, setOpenEditCodeDialog] = useState(false);

  const [isEditCode, setIsEditCode] = useState(false);

  const referralLink = `${REFERRAL_LINK}/${referralCode}`;

  useEffect(() => {
    const code = user?.referral?.referralCode;
    if (code) {
      setReferralCode(code);
    } else {
      setReferralCode(user?.referral?.systemReferralCode || '');
    }
    setReferralCodeLoading(false);
  }, [user?.referral]);

  const handleRegisterReferral = async () => {
    try {
      setReferralCodeLoading(true);
      const response = await apis.referral.registerReferral();
      const registerResult = {
        systemReferralCode: response.result.referralCode,
        joinedAt: response.result.joinedAt,
      };
      dispatch(actions.auth.registerReferral(registerResult));
    } catch (error) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          message: 'registerReferralError',
        }),
      );
    } finally {
      setReferralCodeLoading(false);
    }
  };

  useEffect(() => {
    const hasJoinedReferral =
      user && user?.referral?.joinedAt && user?.referral?.systemReferralCode;

    if (hasJoinedReferral) return;
    handleRegisterReferral();
  }, []);

  const handleCloseEditCodeDialog = () => {
    setOpenEditCodeDialog(false);
  };

  const handleOpenEditCodeDialog = () => {
    setOpenEditCodeDialog(true);
  };

  const handleChangeCode = (code) => {
    dispatch(actions.auth.updateReferralCode(code));
  };

  useEffect(() => {
    const hasOwnReferralCode = user && user?.referral?.referralCode;
    if (hasOwnReferralCode) {
      setIsEditCode(false);
    } else {
      setIsEditCode(true);
    }
  }, [user]);

  const renderInputCode = () => (
    <>
      <ReferralCodeItem
        label={t('referralCodeTitle')}
        value={referralCode}
        isEdit={isEditCode}
        onEdit={handleOpenEditCodeDialog}
        loading={referralCodeLoading}
      />

      <ReferralCodeItem
        label={t('referralLinkTitle')}
        value={referralLink}
        loading={referralCodeLoading}
      />
    </>
  );

  const renderReferralCodeItems = () => (
    <div className="new-ui-referral-code-item-container">
      {renderInputCode()}
    </div>
  );

  return (
    <>
      <StyledReferralCode>
        <div className="referral-code-bg">
          <div className="code-section-container">
            {renderReferralCodeItems()}
            {/* Referral Sharing */}
            {referralCode && (
              <ReferralCodeSharing
                referralLink={referralLink}
                referralCode={referralCode}
              />
            )}
          </div>
        </div>
      </StyledReferralCode>
      {referralCode && (
        <EditCodeDialog
          open={openEditCodeDialog}
          onClose={handleCloseEditCodeDialog}
          code={referralCode}
          onChangeCode={handleChangeCode}
        />
      )}
    </>
  );
};
export default ReferralCode;
